import { LabelProvider } from "./provider";
export interface MipBaseLabelOverride {
  // our label id
  labelId: string;
  // mip label id
  externalLabelId: string;
  override: boolean;
  // omitted for Microsoft, "google-labels" for Google Drive
  externalLabelProvider?: string;
}

export interface MipLabelOverride extends MipBaseLabelOverride {
  addedAt: string;
  orgId: string;
  updatedAt: string;
}

export const LabelTreshHold = Object.freeze({
  min: 67,
  default: 80,
  max: 100,
  normalize(newTrashHold: number) {
    return (
      (newTrashHold - LabelTreshHold.min) /
      (LabelTreshHold.max - LabelTreshHold.min)
    );
  },
});

export type LabelsReadyState = "some" | "all" | "none";

export interface LabelConfigObj {
  labelId: string;
  labelName?: string;
  labelPolicy?: "published" | "hidden";
  policyIds?: string[];
  policyGroupId?: string;
  override?: boolean;
  automate?: boolean;
  confidenceThreshold?: number;
  // runtime
  parentName?: string;
}
export interface ConfigureItem {
  labelCode: number;
  labelName: string;
  levels: Array<{
    id: string;
    level: string;
    automate: boolean;
    overwrite: boolean;
    confidenceThreshold: number;
  }>;
}

export interface MipLabel {
  labelFullName: string; // "Non-sensitive information\\Non-sensitive Business Information"
  labelId: string; // "0f075a83-75a6-423e-bd8a-b17f644496e4"
  labelName: string; //"Non-sensitive Business Information"
  mappedLabelId: string; // "5c077ac5-4da6-4801-861b-5cc98530d093"
  parentId: string; // "51c12e6b-d313-42e4-9d10-7884e487600a"
  parentName: string;
  hasChildren: boolean;
  // which provider this label came from; set when indexed
  service_type?: "ms" | "google";
}

/** what google-label-webapi returns from /google/list-labels */
export interface GoogleApiLabel {
  id: string;
  name: string;
}

/**
 * Google labels are flat — no parent/child hierarchy — so the fields the MIP
 * tree uses for nesting are blanked out. Everything downstream of this treats
 * both providers identically.
 */
export const from_google_to_mip_label = (label: GoogleApiLabel): MipLabel => {
  return {
    labelFullName: label.name,
    labelId: label.id,
    labelName: label.name,
    mappedLabelId: "",
    parentId: "",
    parentName: "",
    hasChildren: false,
  } as MipLabel;
};

export interface MipLabelConfiguration {
  id: string;
  name: string;
  mode: LabelsReadyState;
  labels: string[];
}

export interface MipCognniCombination {
  // cognni label id
  labelId: string;
  // mip label id
  externalLabelId: string;
  confidenceThreshold: number;
  overrideLabelIds: string[];
  runtime: {
    parent_id: string;
    parent_code: number;
    label_name: string;
    external_label_name: string;
  };
}

export interface MappableLabelRef {
  labelId: string;
  labelName: string;
}

export interface MipCommonState {
  /** which external label provider the tabs are currently on */
  provider: LabelProvider;
  /** flat; Google labels have no hierarchy */
  google_labels: MipLabel[];
  labels_config: Record<string, LabelConfigObj>;
  isMipActivated: boolean;
  mipLabelsTree: Array<MipLabel[]>;
  only_native_mip_labels_tree: Array<MipLabel[]>;
  indexed_mip_labels: Record<string, MipLabel>;
  mappable_label_ids: Set<string>;
}

export interface MipOption2State {
  combinations: MipCognniCombination[];
}

export interface CmsLabelPolicy {
  id: string;
  name: string;
  desc: string;
  policies_scripts_ids: string[];
}
